import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {
  "title": "Today was the worst day I've ever had",
  "description": "",
  "published": "2010-06-21T00:00:00.000Z",
  "redirect_from": ["/blog/today-was-the-worst-day-ive-ever-had/swizec/1370"],
  "categories": "Business, Energy drink, Food and Drink, life, London, Opportunities, Uncategorized",
  "hero": "../../../defaultHero.jpg"
};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <ul>
      <li parentName="ul">
        <p parentName="li"><a parentName="p" {...{
            "href": "http://www.flickr.com/photos/95239135@N00/639800453"
          }}><img parentName="a" {...{
              "src": "https://swizec.com/blog/wp-content/uploads/2010/06/639800453_8b1b6f3c26_m.jpg",
              "alt": "Vending Machine for Books",
              "title": "Vending Machine for Books"
            }}></img></a></p>
        <p parentName="li">{`Image by `}<a parentName="p" {...{
            "href": "http://www.flickr.com/photos/95239135@N00/639800453"
          }}>{`Still Burning`}</a>{` via Flickr`}</p>
      </li>
    </ul>
    <p>{`Ok so today has probably been one of the crappiest days in a very very long time. Nothing spectacular happened, just a bunch of small very very irritating and annoying things, just enough to ruin your mood for a whole week.`}</p>
    <p>{`Which is awesome since it's Monday.`}</p>
    <p>{`Even better, I'm going to `}<a parentName="p" {...{
        "href": "http://maps.google.com/maps?ll=51.5080555556,-0.124722222222&spn=0.1,0.1&q=51.5080555556,-0.124722222222%20(London)&t=h",
        "title": "London"
      }}>{`London`}</a>{` tomorrow and am expected to be all chirpy and awesome.`}</p>
    <p>{`Because the day can speak for itself, I'm just going to list everything:`}</p>
    <ol>
      <li parentName="ol">{`I got up quite a bit later than I intended.`}</li>
      <li parentName="ol">{`It was cold and incredibly humid outside.`}</li>
      <li parentName="ol">{`By the time I got to uni to have a grade officially noted down, I was dripping sweat.`}</li>
      <li parentName="ol">{`Went to hackerspace to study, made tea.`}</li>
      <li parentName="ol">{`10 minutes later realised I'd forgotten my calculator at home, went get it.`}</li>
      <li parentName="ol">{`Dripping sweat when got home.`}</li>
      <li parentName="ol">{`This time get in car and go back to hackerspace.`}</li>
      <li parentName="ol">{`Going for calculator took an hour. Made new tea.`}</li>
      <li parentName="ol">{`Ten minutes later classmates called, let's go study at a random open classroom.`}</li>
      <li parentName="ol">{`It is now almost noon and I've only had a few sips of tea.`}</li>
      <li parentName="ol">{`All vending machines at the faculty are out of energy drinks, everyone's studying.`}</li>
      <li parentName="ol">{`With the last change I've got I grab a coke.`}</li>
      <li parentName="ol">{`At 3pm the exam starts and it's a fucking assrape. I literally felt the professor's dick go up my arse when I put my eyes on the problem.`}</li>
      <li parentName="ol">{`Struggle through somewhat solving everything.`}</li>
      <li parentName="ol">{`It took so long I couldn't pick a time/date to go get my grade. Got one that is on a day when I'm in London.`}</li>
      <li parentName="ol">{`Go back to hackerspace to mostly hang out, do some business stuff.`}</li>
      <li parentName="ol">{`Laptop runs out of disk. Quickly empty trash.`}</li>
      <li parentName="ol">{`Emptying trash takes two hours.`}</li>
      <li parentName="ol">{`While emptying trash the only data file for my time logging app where I log pretty much everything I do so I can have an oversee of what I'm doing with my time ... goes missing.`}</li>
      <li parentName="ol">{`Fine I'll just restore it from backups.`}</li>
      <li parentName="ol">{`Mate beats me in almost every single game of Guitar Hero.`}</li>
      <li parentName="ol">{`Get home, start restoring that file from backups.`}</li>
      <li parentName="ol">{`Find out someone had turned Time Machine off on December 6th 2009.`}</li>
      <li parentName="ol">{`Give up. The day is officially horrible. The only way it could get worse is if I magically break my leg while sleeping.`}</li>
    </ol>
    <p><a parentName="p" {...{
        "href": "http://www.zemanta.com/",
        "title": "Enhanced by Zemanta"
      }}><img parentName="a" {...{
          "src": "https://img.zemanta.com/zemified_e.png?x-id=940b47df-4429-48c5-bd5d-5a6a9ce36151",
          "alt": "Enhanced by Zemanta"
        }}></img></a></p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      